import { useEffect } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { startCase } from "lodash";
import { useAtom } from "jotai";
import Headers from "../../../shared/Header/Header";
import { decodeJWT } from "../../../utils/jwt";

// MUI imports
import {
    Breadcrumbs,
    Link,
    Container,
    Paper,
    Box,
    Typography,
} from "@mui/material";
import settingsAtom, { getUserData } from "../../../atoms/settings/SettingsAtom";
import LogisticsManagementAtom from "../../../atoms/logistics/LogisticsManagementAtom";

const RootLayout = () => {
    const navigate = useNavigate();
    const [, setUserDetails] = useAtom(getUserData);
    const params = useLocation();
    const [data] = useAtom(settingsAtom);
    const { blockList } = data;
    const [dataValue] = useAtom(LogisticsManagementAtom);

    useEffect(() => {
        const token = Cookies.get("access_token");
        if (!token) {
            navigate("/login", { replace: true });
        } else {
            const decoded = decodeJWT(token);
            setUserDetails(decoded);

            if (params.pathname === "/") {
                navigate("/dashboard", { replace: true });
            }
        }
    }, [navigate, setUserDetails, params.pathname]);

    const pathSegments = params.pathname.split("/").filter((item) => item !== "");


    return (
        <Box sx={{ backgroundColor: '#f5f5f5' }}>
            <Headers />

            <Container
                maxWidth={false}
                disableGutters
                sx={{ px: 2}}
            >
                <Breadcrumbs mt={1} sx={{ fontSize: '17px' }} aria-label="breadcrumb">
                    <Link
                        underline="hover"
                        color="inherit"
                        onClick={() => navigate("/")}
                        sx={{ cursor: "pointer" }}
                    >
                        Surya
                    </Link>

                    {pathSegments.map((segment, index) => {
                        const to = `/${pathSegments.slice(0, index + 1).join("/")}`;
                        const isLast = index === pathSegments.length - 1;

                        const getSegmentText = () => {

                            if (
                                index === 3 &&
                                dataValue?.currentLaydown &&
                                (pathSegments?.[2] === "inventory" || pathSegments?.[2] === "scope")
                            ) {
                                return dataValue.currentLaydown.name;
                            }

                            if (Number(segment) && blockList?.[segment]) {
                                return blockList[segment];
                            }

                            return startCase(segment);
                        };

                        if (isLast) {
                            return (
                                <Typography
                                    key={index}
                                    color="text.primary"
                                    fontWeight="bold"
                                    sx={{ fontSize: '17px' }}
                                >
                                    {getSegmentText()}
                                </Typography>
                            );
                        } else {
                            return (
                                <Link
                                    key={index}
                                    underline="hover"
                                    color="inherit"
                                    onClick={() => navigate(to)}
                                    sx={{ cursor: "pointer" }}
                                >
                                    {getSegmentText()}
                                </Link>
                            );
                        }
                    })}
                </Breadcrumbs>


                <Paper
                    elevation={1}
                    sx={{
                        mt: 1,
                        backgroundColor: 'white',
                        minHeight: "calc(100vh - 120px)",
                        borderRadius: 2,
                        fontSize: '16px',
                    }}
                >
                    <Outlet />
                </Paper>
            </Container>
        </Box>
    );
};

export default RootLayout;
